import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable, of, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";

import { LoaderManagerService, ErrorLogService } from "../services";

@Injectable()
export class HandleHttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private loaderManagerService: LoaderManagerService,
    private errorLogService: ErrorLogService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status !== 401) {
            let err = error;
            if (error.error) {
              err = error.error;
              let mappedError = {};
              for (let key of Object.keys(err)) {
                mappedError[key.toLowerCase()] = err[key];
              }

              err = <HttpErrorResponse>mappedError;
            }
            // TODO: this has been disabled for better user experience
            //this.errorLogService.showError(err.message, err);
            console.log(err)
            return throwError(error);
          }
          throw error;
        }
      }),
      finalize(() => {
        this.loaderManagerService.onRequestStop(request);
      })
    );
  }
}
